<template>
  	<div class="animated fadeIn">
		<b-row>
		    <b-col cols="12">
				<b-card header-tag="header" footer-tag="footer">
			        <div slot="header">
						<i class="fa fa-align-justify"></i><strong> {{$trans[$route.meta.trans_key]['comp_title']}}<span>, {{year}}</span></strong> <small v-if="!loading1"> - {{item1.name}}</small>
			        </div>
			        <div>
						<b-row>
							<b-col lg="6">
								<b-row>
									<b-col md="12">
										<b-form-group :label="$trans[$route.meta.trans_key]['district']" label-for="sel-district">
											<b-form-select id="sel-district" v-model="id_item_selected">
												<option v-for="item in all_items" :key="item.id" :value="item.id">{{item.name}}</option>
											</b-form-select>
										</b-form-group>
										<b-form-group :label="$trans[$route.meta.trans_key]['year']" label-for="sel-year">
											<b-form-select id="sel-year" v-model="year">
												<option v-for="(item, idx) in years" :key="idx" :value="item">{{item}}</option>
											</b-form-select>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>
							<b-col lg="6">
								<b-row>
									<b-col md="12">
										<p class="mt-0" v-html="data.total_text"></p>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
						<b-row class="mt-3">
							<b-col :lg="item.col_size" v-for="(item, idx) in data.data" :key="idx">
								<b-card header-tag="header" footer-tag="footer">
									<div slot="header">
										<i class="fa fa-align-justify"></i><strong v-if="!loading1"> {{item.title}}</strong>
							        </div>
									<div :class="(!loading1) ? 'has_data' : ''" class="card-loader-container">
										<loader v-if="loading1"></loader>
										<b-col v-if="typeof item.table_data !== 'undefined'" sm="4" offset-sm="8">
											<b-form-select v-model="charts_visual_types_old[idx]" :id="'choose-display_' +idx">
												<option v-for="c_type in charts_visual_types_available" :value="c_type" :key="c_type">{{c_type}}</option>
											</b-form-select>
										</b-col>
										<div v-if="charts_visual_types_old[idx] === $trans[$route.meta.trans_key]['table'] && typeof item.table_data !== 'undefined'" class="censos_table">
											<datatable v-bind:data_table="item.table_data"></datatable>
										</div>
										<div v-else :class="(item.table_data) ? 'censos_chart' : ''">
											<pie-chart v-if="item.chart_data.type === 'pie'" v-bind:chartData="item.chart_data"></pie-chart>
											<line-chart v-else-if="item.chart_data.type === 'line'" v-bind:chartData="item.chart_data"></line-chart>
											<bar-chart v-else-if="item.chart_data.type === 'bar'" v-bind:chartData="item.chart_data"></bar-chart>
										</div>
									</div>
								</b-card>
							</b-col>
						</b-row>
					</div>
			    </b-card>
			</b-col>
		</b-row>
	</div>
</template>
<script>
export default {
	name: 'General_Comp',
	data() {
		return {
			disclaimer_active: null,
			modal_active: false,
			all_items: [],
			item_details: {},
			year: '',
			years: [],
			id_item_selected: this.$route.params.id,
			loading1: true,
			data: [],
			charts_visual_types_old: [this.$trans[this.$route.meta.trans_key]['graphic'], this.$trans[this.$route.meta.trans_key]['graphic'], this.$trans[this.$route.meta.trans_key]['graphic']],
			charts_visual_types_available: [this.$trans[this.$route.meta.trans_key]['table'], this.$trans[this.$route.meta.trans_key]['graphic']],
		}
	},
	methods: {
		get_data: function() {
			const that = this;
			that.get_req(this.$route.meta.data_end_point+ '/' +that.year+ '/' +that.id_item_selected,
				function() { // before
					that.loading1 = true;
	            },
				function(response) { // success
					that.data = response.body;
					that.loading1 = false;
				},
				function(response) { // fail
					alert('ajax main.js error: '+ response.status);
				},
				function(response) {
					
				});
		},
		get_years: function() {
			const that = this;
			that.get_req(this.$route.meta.years_end_point,
				function() { // before
					//that.loading = true;
	            },
				function(response) { // success
					that.years = response.body;
					that.year = that.years[0];
					// that.id_item_selected = that.get_starter_item(that.all_items, that.id_item_selected).id;
				},
				function(response) { // fail
					alert('ajax main.js error: '+ response.status);
				},
				function(response) {
					
				});
		},
		init_comp: function() {
			if(this.globs['districts'] !== null) {
				this.all_items = this.globs['districts'];
				if(typeof this.$route.meta.default_opt1 === 'undefined') {
					this.id_item_selected = this.get_starter_item(this.globs['districts'], this.id_item_selected).id;
				}
				else if(this.all_items[0] !== this.$route.meta.default_opt1) {
					this.all_items.unshift(this.$route.meta.default_opt1);
				}
				else {	
					this.id_item_selected = this.all_items[0].id;
				}
				this.get_years();
				return;
			}
			const that = this;
			that.get_req(this.$route.meta.start_end_point,
				function() { // before
					//that.loading = true;
	            },
				function(response) { // success
					that.all_items = response.body;
					that.globs['districts'] = that.all_items;
					if(typeof that.$route.meta.default_opt1 === 'undefined') {
						that.id_item_selected = that.get_starter_item(that.all_items, that.id_item_selected).id;
					}
					else {	
						that.all_items.unshift(that.$route.meta.default_opt1);
						// that.id_item_selected = that.all_items[0].id;
					}
					that.get_years();
				},
				function(response) { // fail
					alert('ajax main.js error: '+ response.status);
				},
				function(response) {
					
				});
		},
	},
	watch: {
		observer: function(new_val, old_val) {
			if(new_val.every((item) => typeof item !== 'undefined' && item !== '')) { // both exist with valid val
				this.item_details = this.all_items.find((item) => item.id == this.id_item_selected);
				this.get_data();
			}
		},
		'$route.params.id': function(new_val, old_val) {
			if(typeof new_val === 'undefined') { //back button porpuses
				this.$router.go(-1);
			}
			else if(this.id_item_selected != new_val) {
				this.id_item_selected = new_val;
			}
		},
		item_details: function(new_val, old_val) {
			let params = this.$route.params;
			params.id = this.id_item_selected;
			params.slug = this.string_to_slug(this.item_details.name);
			this.$router.push({name: this.$route.name, params: params});
		}
	},
	computed: {
		observer: function() {
			return [this.id_item_selected, this.year];
		},
		item1: function() {
			return this.all_items.find((item) => item.id == this.id_item_selected);
		}
	},
	created: function() {
		this.init_comp();
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.local-badge {
	width: 160px;
}
</style>